// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2LLC5","question":"Question_question__2uXM1","description":"Question_description__2lUKt"};